export const STRIPE_KEY='pk_test_51KgST9Jz0Xxp8umGhlMbwhGZywO1hI5EZbZDAEiXUZysXa6rcJ94BSQezjAdmsR2ltHkg7BwAWs2x3b0t1QJJ7xX00bg7zFH2I'


